import { IS_USA_MARKET } from "./EmpUtil";

// Before a dealer is picked, only the Field Support user's own market is known.
export const getDealershipMarket = (user) =>
  String(user?.commonDealerId || user?.commonId || "").split("|")[0] ||
  user?.market;

export const isUsFieldSupportContext = (user) =>
  IS_USA_MARKET(user?.market) && IS_USA_MARKET(getDealershipMarket(user));
